/**
 * We separate motorcycles to be either smaller than 1.7m or larger (170 in centimeters)
 */
export const displayMotorcycleVehicleLength = 170